import { CoreAPI, SDKConfig } from '@hero/sdk-core';
import { createAuthAPI } from './api/auth';
import { createOrdersAPI } from './api/orders';
import { createOffersAPI } from './api/offers';
import { createVehiclesAPI } from './api/vehicles';
import { createMembersAPI } from './api/members';
import { createDriversAPI } from './api/drivers';
import { createLocationAPI } from './api/location';
import { createAnalyticsAPI } from './api/analytics';
import { createPaymentAPI } from './api/payment';
import { createPriceAPI } from './api/price';
import { createClientConfigAPI } from './api/client-config';
import { createRoutesAPI } from './api/routes';
import { createAgreementsAPI } from './api/agreements';
import { createConnectionsAPI } from './api/connections';
import { createProfilesAPI } from './api/profiles';
import { createOrgsAPI } from './api/orgs';
import { createSalesAPI } from './api/sales';
import { createAppsAPI } from './api/apps';

/**
 * CarrierAPI - Carrier-specific API methods
 * Provides type-safe access to carrier endpoints with schema validation
 */
export class CarrierAPI extends CoreAPI {
  public readonly auth: ReturnType<typeof createAuthAPI>;
  public override readonly orders: ReturnType<typeof createOrdersAPI>;
  public readonly offers: ReturnType<typeof createOffersAPI>;
  public readonly vehicles: ReturnType<typeof createVehiclesAPI>;
  public readonly members: ReturnType<typeof createMembersAPI>;
  public readonly drivers: ReturnType<typeof createDriversAPI>;
  public readonly location: ReturnType<typeof createLocationAPI>;
  public readonly analytics: ReturnType<typeof createAnalyticsAPI>;
  public readonly payment: ReturnType<typeof createPaymentAPI>;
  public readonly price: ReturnType<typeof createPriceAPI>;
  public readonly clientConfig: ReturnType<typeof createClientConfigAPI>;
  public readonly routes: ReturnType<typeof createRoutesAPI>;
  public readonly agreements: ReturnType<typeof createAgreementsAPI>;
  public override readonly connections: ReturnType<typeof createConnectionsAPI>;
  public override readonly profiles: ReturnType<typeof createProfilesAPI>;
  public override readonly orgs: ReturnType<typeof createOrgsAPI>;
  public override readonly sales: ReturnType<typeof createSalesAPI>;
  public readonly apps: ReturnType<typeof createAppsAPI>;

  constructor(config: SDKConfig) {
    super(config);

    this.auth = createAuthAPI(this);
    this.orders = createOrdersAPI(this);
    this.offers = createOffersAPI(this);
    this.vehicles = createVehiclesAPI(this);
    this.members = createMembersAPI(this);
    this.drivers = createDriversAPI(this);
    this.location = createLocationAPI(this);
    this.analytics = createAnalyticsAPI(this);
    this.payment = createPaymentAPI(this);
    this.price = createPriceAPI(this);
    this.clientConfig = createClientConfigAPI(this);
    this.routes = createRoutesAPI(this);
    this.agreements = createAgreementsAPI(this);
    this.connections = createConnectionsAPI(this);
    this.profiles = createProfilesAPI(this);
    this.orgs = createOrgsAPI(this);
    this.sales = createSalesAPI(this);
    this.apps = createAppsAPI(this);
  }
}
export type CarrierApiInt = InstanceType<typeof CarrierAPI>;
